import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import routes from '../../routes';
import SearchUser from './components/SearchUser';

import './AdminDashboard.styles.scss';

type AdminDashboardProps = {
  className?: string;
};

const AdminDashboard: React.FC<AdminDashboardProps> = (props) => {
  const { className } = props;

  const adminDashboardRoutes = useMemo(
    () => routes.filter(({ labelString }) => labelString),
    [],
  );

  const classes = classNames('admin-dashboard', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <h1>{t('bossModeDashboard')}</h1>

      <nav>
        {adminDashboardRoutes.map(
          ({ path, labelString, labelDescription, Icon }) => (
            <Link key={labelString} to={path}>
              <span className="title">
                {Icon && <Icon />}
                {t(labelString)}
              </span>
              <span>{t(labelDescription)}</span>
            </Link>
          ),
        )}
      </nav>

      <SearchUser />
    </div>
  );
};

export default AdminDashboard;
